import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  body {
    background: #F5F7FA;
    font-size: 16px;
  }

  img {
    display: block;
    max-width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    color: #26427C;
    line-height: 1.5em;
    margin-bottom: 0.8em;
  }

  h1 {
    margin: 12px 0 15px;
    font-size: 1.5em;
  }

  h3 {
    font-size: 1em;
  }

  p {
    line-height: 1.5em;
    margin-bottom: 1.7em;
  }
`;
